import React, { useEffect, useMemo, useState } from "react";
import Select, { components as defaultComponents } from "react-select";
import "../assets/scss/transfer.scss";

interface IFancySelect {
  options: { value: number; label: string }[];
  name: string;
  label: string;
  placeholder: string;
  value?:
    | { value: number; label: string }
    | { value: number; label: string }[]
    | null;
  isSearchable?: boolean;
  components?: any;
  errors?: any;
  isRequired?: boolean;
  onMenuScrollToBottom?: () => void;
  onInputChange?: (e: string) => void;
  onChange?: (e: any | null) => void;
  isMulti?: boolean;
  className?: string;
  disabled?: boolean;
}

const FancySelect: React.FC<IFancySelect> = ({
  options,
  name,
  label,
  placeholder,
  value,
  errors,
  components,
  isSearchable,
  isRequired,
  isMulti,
  onMenuScrollToBottom,
  onInputChange,
  onChange,
  className,
  disabled = false,
}) => {
  const [isMobile, setIsMobile] = useState(false);
  const [hasInteracted, setHasInteracted] = useState(false);
  const [searchEnabled, setSearchEnabled] = useState(true);

  useEffect(() => {
    const checkMobile = () =>
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      ) || window.innerWidth < 768;

    setIsMobile(checkMobile());
    const onResize = () => setIsMobile(checkMobile());
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    setSearchEnabled(!isMobile);
    setHasInteracted(false);
  }, [isMobile]);

  return (
    <div
      className={
        className ? `position-relative ${className}` : "position-relative"
      }
    >
      <label className="form-label">
        {label} {isRequired ? <span style={{ color: "#f00" }}>*</span> : null}
      </label>
      <Select
        styles={{
          control: (provided, state) => ({
            ...provided,
            borderColor: errors && errors[name] ? "#F2667A" : "#ced4da",
          }),
          dropdownIndicator: (provided, state) => ({
            ...provided,
            color: errors && errors[name] ? "#F2667A" : "#ced4da",
          }),
          menu: (base) => ({
            ...base,
            position: 'absolute',
            zIndex: 1000,
          }),
        }}
        value={value}
        className={errors && errors[name] ? "is-invalid" : ""}
        placeholder={placeholder}
        isSearchable={isSearchable && (!isMobile || searchEnabled)}
        options={options}
        components={components}
        onMenuScrollToBottom={onMenuScrollToBottom}
        onInputChange={onInputChange}
        onChange={onChange}
        isMulti={isMulti}
        isDisabled={disabled}
        menuPosition="absolute"
        openMenuOnFocus={false}
        onMenuOpen={() => {
          if (isMobile && !hasInteracted) {
            setHasInteracted(true);
            setSearchEnabled(false);
            const active = document.activeElement as HTMLElement | null;
            if (active && (active.tagName === "INPUT" || active.tagName === "TEXTAREA")) {
              active.blur();
            }
          }
        }}
        onMenuClose={() => {
          if (isMobile && hasInteracted) {
            setSearchEnabled(true);
          }
        }}
      />

      {errors && errors[name] ? (
        <div className="invalid-feedback">{errors[name]["message"]}</div>
      ) : null}
    </div>
  );
};

export default FancySelect;
